<page-heading
  [title]="
    (isNew
      ? 'integrations.agentsForm.titleAdd'
      : 'integrations.agentsForm.titleEdit'
    ) | translate
  "
  [description]="
    (isNew
      ? 'integrations.agentsForm.descriptionAdd'
      : 'integrations.agentsForm.descriptionEdit'
    ) | translate
  "
  [hasBreadcrumb]="true"
  [breadcrumb]="breadcrumb"
/>

@if (loadingContent) {
<content-loading-list />
}

<form [formGroup]="formGroup">
  <div class="row">
    <div class="col-xs-12">
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-xs-12">
              <label class="form-label">{{ 'integrations.agentsForm.labelName' | translate }}</label>
              <input
                type="text"
                class="form-control"
                maxlength="100"
                formControlName="name"
                [placeholder]="'integrations.agentsForm.placeholderName' | translate"
                required
              />
              <field-error-component
                [field]="'name'"
                [label]="'integrations.agentsForm.fieldLabelName' | translate"
                [formGroup]="formGroup"
              />
              <small class="d-block text-end text-muted mt-1">
                {{ formGroup.get("name")?.value?.length ?? 0 }}/100 caracteres
              </small>
            </div>
            <div class="col-xs-12">
              <label class="form-label">{{ 'integrations.agentsForm.labelCompanyName' | translate }}</label>
              <input
                type="text"
                class="form-control"
                maxlength="100"
                formControlName="jobName"
                [placeholder]="'integrations.agentsForm.placeholderCompanyName' | translate"
                required
              />
              <field-error-component
                [field]="'jobName'"
                [label]="'integrations.agentsForm.fieldLabelCompanyName' | translate"
                [formGroup]="formGroup"
              />
              <small class="d-block text-end text-muted mt-1">
                {{ formGroup.get("jobName")?.value?.length ?? 0 }}/100
                caracteres
              </small>
            </div>
            <div class="col-xs-12">
              <label class="form-label">{{ 'integrations.agentsForm.labelOfficialSite' | translate }}</label>
              <input
                type="text"
                class="form-control"
                maxlength="200"
                formControlName="jobSite"
                [placeholder]="'integrations.agentsForm.placeholderOfficialSite' | translate"
                required
              />
              <field-error-component
                [field]="'jobSite'"
                [label]="'integrations.agentsForm.fieldLabelOfficialSite' | translate"
                [formGroup]="formGroup"
              />
              <small class="d-block text-end text-muted mt-1">
                {{ formGroup.get("jobSite")?.value?.length ?? 0 }}/200
                caracteres
              </small>
            </div>
            <div class="col-xs-12">
              <label class="form-label">{{ 'integrations.agentsForm.labelBehavior' | translate }}</label>
              <textarea
                type="text"
                class="form-control"
                maxlength="3000"
                formControlName="description"
                [placeholder]="'integrations.agentsForm.placeholderBehavior' | translate"
                required
              ></textarea>
              <field-error-component
                [field]="'description'"
                [label]="'integrations.agentsForm.fieldLabelBehavior' | translate"
                [formGroup]="formGroup"
              />
              <small class="d-block text-end text-muted mt-1">
                {{ formGroup.get("description")?.value?.length ?? 0 }}/3000
                caracteres
              </small>
            </div>
            <div class="col-xs-12">
              <label class="form-label">{{ 'integrations.agentsForm.labelCompanyDescription' | translate }}</label>
              <textarea
                type="text"
                class="form-control"
                maxlength="3000"
                formControlName="jobDescription"
                [placeholder]="'integrations.agentsForm.placeholderCompanyDescription' | translate"
                required
              ></textarea>
              <field-error-component
                [field]="'jobDescription'"
                [label]="'integrations.agentsForm.fieldLabelCompanyDescription' | translate"
                [formGroup]="formGroup"
              />
              <small class="d-block text-end text-muted mt-1">
                {{ formGroup.get("jobDescription")?.value?.length ?? 0 }}/3000
                caracteres
              </small>
            </div>

            <div class="col-xs-12 mb-3">
              <label class="form-label">{{ 'integrations.agentsForm.labelCommunicationStyle' | translate }}</label>
              <select
                #ComunicationSel
                class="form-select"
                formControlName="communicationType"
                (change)="onCommunicationSelection(ComunicationSel.value)"
              >
                <option value="" disabled>{{ 'integrations.agentsForm.optionSelectStyle' | translate }}</option>
                <option [value]="'FORMAL'">{{ 'integrations.agentsForm.communicationStyleFormal' | translate }}</option>
                <option [value]="'NORMAL'">{{ 'integrations.agentsForm.communicationStyleNormal' | translate }}</option>
                <option [value]="'RELAXED'">{{ 'integrations.agentsForm.communicationStyleRelaxed' | translate }}</option>
              </select>
              <field-error-component
                [field]="'communicationType'"
                [label]="'integrations.agentsForm.fieldLabelCommunicationStyle' | translate"
                [formGroup]="formGroup"
              ></field-error-component>
            </div>
            <div class="col-xs-12 mb-3">
              <label class="form-label">{{ 'integrations.agentsForm.labelAgentType' | translate }}</label>
              <select
                #AgentSel
                class="form-select"
                formControlName="type"
                (change)="onAgentTypeSelection(AgentSel.value)"
              >
                <option value="" disabled>{{ 'integrations.agentsForm.optionSelectAgentType' | translate }}</option>
                <option [value]="'SUPPORT'">{{ 'integrations.agentsForm.agentTypeSupport' | translate }}</option>
                <option [value]="'SALE'">{{ 'integrations.agentsForm.agentTypeSale' | translate }}</option>
                <option [value]="'PERSONAL'">{{ 'integrations.agentsForm.agentTypePersonal' | translate }}</option>
              </select>
              <field-error-component
                [field]="'type'"
                [label]="'integrations.agentsForm.fieldLabelAgentType' | translate"
                [formGroup]="formGroup"
              ></field-error-component>
            </div>
            <div class="col-xs-12 mb-3">
              <label class="form-label">{{ 'integrations.agentsForm.labelSelectChannel' | translate }}</label>
              <select
                #ChannelSel
                class="form-select"
                formControlName="channels"
                (change)="onChannelsSelection(ChannelSel)"
              >
                <option value="" disabled>{{ 'integrations.agentsForm.optionSelectChannel' | translate }}</option>
                @for(channel of channels; track $index ) {
                <option [value]="channel._id">{{ channel.name }}</option>
                }
              </select>
              <field-error-component
                [field]="'channels'"
                [label]="'integrations.agentsForm.fieldLabelChannel' | translate"
                [formGroup]="formGroup"
              ></field-error-component>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>

<div class="row">
  <div class="col-12 gap-2 d-flex justify-content-end pb-4">
    <button
      class="btn btn-outline-secondary"
      [disabled]="!formGroup.valid || loading"
      (click)="goBack()"
    >
      {{ 'integrations.agentsForm.buttonCancel' | translate }}
    </button>
    <button
      class="btn btn-primary"
      type="submit"
      [disabled]="!formGroup.valid || loading"
      (click)="onSubmit()"
    >
      {{ !loading ? (isNew ? ('integrations.agentsForm.buttonSave' | translate) : ('integrations.agentsForm.buttonUpdate' | translate)) : "" }}
      @if (loading) {
      <mat-spinner [diameter]="15" [color]="'accent'" mode="indeterminate" />
      }
    </button>
  </div>
</div>
